import React from "react";
import Logo from "views/icons/Logo";
import { ChevronLeftIcon } from "lucide-react";

const MobileNav = () => {
  return (
    <>
      <nav className="fixed md:hidden left-0 top-0 bg-white px-2 py-3 flex items-center justify-center w-full">
        <a href="/rewards_users/login">
          <Logo />
        </a>
      </nav>
      <a
        href="/rewards_users/login"
        className="border-none bg-none appearance-none py-1 flex md:hidden items-center justify-start group hover:no-underline mb-4"
      >
        <span className="inline-flex items-center justify-center rounded-full bg-white border border-gray-300 p-2 mr-2 group-hover:bg-gray-100 group-hover:border-gray-200">
          <ChevronLeftIcon className="h-4 w-4 text-primary-700 group-hover:text-primary-500" />
        </span>
        <span className="text-sm text-primary-700 group-hover:text-primary-500">
          Back to log in
        </span>
      </a>
    </>
  );
};
export default MobileNav;
